module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Arandano.22c5d8b9.pdf";